/** Batch run: the queue and every field's own status, visible while it grinds. */

import { T } from "../strings";
import type { QueueEntry, QueueStatus } from "../state/useWorkspace";

const STATUS_WORD: Record<QueueStatus, string> = {
  queued: T.run.queued,
  running: T.run.inProgress,
  done: T.run.done,
  error: T.run.error,
};

interface Props {
  queue: QueueEntry[];
  onClear: () => void;
  onSelect: (fieldId: number) => void;
}

export function BatchQueue({ queue, onClear, onSelect }: Props) {
  if (queue.length === 0) return null;

  const finished = queue.filter(
    (entry) => entry.status === "done" || entry.status === "error",
  ).length;

  return (
    <section className="k-section k-section--tight">
      <div className="k-section__head">
        <span className="k-label">{T.run.queue}</span>
        <span className="k-mono k-hint">
          {finished}/{queue.length}
        </span>
      </div>
      <div className="k-queue k-scroll">
        {queue.map((entry) => (
          <div className="k-queuerow" key={entry.fieldId}>
            <button
              type="button"
              className="k-btn k-btn--ghost"
              style={{ justifyContent: "flex-start" }}
              onClick={() => onSelect(entry.fieldId)}
            >
              {entry.fieldName}
            </button>
            <span className="k-queuerow__status">
              {STATUS_WORD[entry.status]}
              {entry.error ? ` · ${entry.error}` : ""}
            </span>
          </div>
        ))}
      </div>
      <button type="button" className="k-btn k-btn--ghost" onClick={onClear}>
        {T.run.cancelQueue}
      </button>
    </section>
  );
}
